import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";
import { NAV_LINKS } from "@/data/site";

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 8);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`sticky top-0 z-50 transition-colors duration-300 ${
                scrolled
                    ? "border-b border-haze bg-ink/85 backdrop-blur-md"
                    : "border-b border-transparent"
            }`}
        >
            <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-5 sm:px-8">
                <Logo />

                <nav className="hidden items-center gap-8 lg:flex">
                    {NAV_LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-${l.to.replace(/\//g, "")}`}
                            className={({ isActive }) =>
                                `text-sm transition-colors hover:text-text-hi ${
                                    isActive ? "text-rule" : "text-text-lo"
                                }`
                            }
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden items-center gap-5 lg:flex">
                    <span
                        data-testid="nav-signin"
                        className="cursor-default text-sm text-text-lo"
                        title="Coming soon"
                    >
                        Sign in
                    </span>
                    <Link
                        to="/#early-access"
                        data-testid="nav-early-access"
                        className="btn-amber rounded px-4 py-2 text-sm font-semibold"
                    >
                        Get early access
                    </Link>
                </div>

                <button
                    onClick={() => setOpen((v) => !v)}
                    data-testid="mobile-menu-toggle"
                    className="text-text-hi lg:hidden"
                    aria-label="Toggle menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="mobile-menu"
                    className="border-t border-haze bg-ink lg:hidden"
                >
                    <div className="flex flex-col gap-1 px-5 py-4">
                        {NAV_LINKS.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                className={({ isActive }) =>
                                    `rounded px-2 py-3 text-sm ${
                                        isActive
                                            ? "text-rule"
                                            : "text-text-lo"
                                    }`
                                }
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/#early-access"
                            className="btn-amber mt-3 rounded px-4 py-3 text-center text-sm font-semibold"
                        >
                            Get early access
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Navbar;
